"use client"
import React, { useState } from "react"

const CancelSubscription = ({ openModal }) => {
  return (
    <div className="alert alert-danger-subtle border-danger-subtle">
      <h5 className="fw-semibold kpi-heading mb-2">Cancel Subscription</h5>
      <div className="alert alert-danger border-0 py-2 mt-3">
      <small className="text-danger-emphasis mb-3">Need to cancel your subscription? We're sorry to see you go.</small>
      </div>
      <button className="btn cancel-btn fw-medium" onClick={() => openModal("cancel")}>
        Cancel Subscription
      </button>
    </div>
  )
}

export default CancelSubscription
